import React from "react";
import PropTypes from "prop-types";

import Message from "./Message";

const ListMessages = ({ searchString, data, destroyMessage, currentUserIsAdmin }) => (
  <div>
    {data.map(item => (
      <Message
        key={item.id}
        searchString={searchString}
        data={item}
        destroyMessage={destroyMessage}
        currentUserIsAdmin={currentUserIsAdmin}
      />
    ))}
  </div>
);

ListMessages.propTypes = {
  searchString: PropTypes.string,
  data: PropTypes.array.isRequired
};

export default ListMessages;
